// Module
var code = "<div ng-class=\"styleclass\" class=\"modal\" id=\"{{modalid}}\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"false\"> <div class=\"modal-dialog\" ng-class=\"dialogstyle\"> <div class=\"modal-content\"> <ng-transclude></ng-transclude> </div> </div> </div> ";
// Exports
module.exports = code;